import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
    templateUrl: "./canjes-modal-error.component.html",
    styleUrls: ["./canjes-modal-error.component.scss"]
})
export class CanjesModalErrorComponent {
    public mensaje = "";

    constructor(private activeModal: NgbActiveModal) { }

    public cerrar(mensaje: string): void {
        this.activeModal.close(mensaje);
    }
}
